import type { PageProps } from 'keycloakify/login/pages/PageProps';
import Text from '@bankiru/ui-kit/core/Text';
import type { KcContext } from '../../KcContext';
import type { I18n } from '../../i18n';
import { LinkText } from '@bankiru/ui-kit/components/Link/LinkText';

export default function LoginPageExpired(
	props: PageProps<Extract<KcContext, { pageId: 'login-page-expired.ftl' }>, I18n>,
) {
	const { kcContext, i18n, doUseDefaultCss, Template, classes } = props;

	const { url } = kcContext;

	const { msg, msgStr } = i18n;

	return (
		<Template
			kcContext={kcContext}
			i18n={i18n}
			doUseDefaultCss={doUseDefaultCss}
			classes={classes}
			headerNode={msg('pageExpiredTitle')}
		>
			<p id="instruction1" className="instruction">
				<Text size="fs16" color="primary">
					{`${msgStr('pageExpiredMsg1')} `}
					<LinkText skin="blue" href={url.loginRestartFlowUrl}>
						{msg('pageExpiredRefresh')}
					</LinkText>
				</Text>
			</p>
		</Template>
	);
}
